module.exports = __webpack_public_path__ + "media/images/cards/cc-jcb-579a4adbc54a8290ffe010272a465e57.svg";